// eslint-disable-next-line import/prefer-default-export
export const CUSTOMIZATION_ENABLED_TAG = 'pro-customization';
export const BULK_AGENTS_REMOVAL_TAG = 'bulk-agents-removal';
export const NOT_FIRST_LOGIN_TAG = 'not-first-login';
